import { RevenueHistory } from '../services/revenuehistory/revenueHistoryService';

export const ALL_MENUS_SENTINEL = '__all__';
export const ACTIVE_DISHES_SENTINEL = '__active_dishes__';

export type CostPriceMenuMode = 'all' | 'active_dishes' | 'menus';

export function getCostPriceMenuMode(filters: string[]): CostPriceMenuMode {
  if (filters.includes(ALL_MENUS_SENTINEL)) return 'all';
  if (filters.includes(ACTIVE_DISHES_SENTINEL)) return 'active_dishes';
  return 'menus';
}

// Mode-exclusive selection rules. The two sentinels and real menu ids cannot
// coexist; toggling a sentinel snaps to that single value, toggling a menu
// strips sentinels, and emptying the selection auto-flips back to All.
export function reconcileCostPriceMenuSelection(
  oldArr: string[],
  newArr: string[]
): string[] {
  const oldSet = new Set(oldArr);
  const added = newArr.filter(v => !oldSet.has(v));

  if (added.includes(ALL_MENUS_SENTINEL)) return [ALL_MENUS_SENTINEL];
  if (added.includes(ACTIVE_DISHES_SENTINEL)) return [ACTIVE_DISHES_SENTINEL];

  const realIds = newArr.filter(
    v => v !== ALL_MENUS_SENTINEL && v !== ACTIVE_DISHES_SENTINEL
  );
  if (realIds.length === 0) return [ALL_MENUS_SENTINEL];
  return realIds;
}

// Names of items that appear in any revenue history entry within the last
// 30 days. Anchored at `now` (defaults to today).
export function getActiveDishNames(
  revenueHistoryList: RevenueHistory[],
  now: Date = new Date()
): Set<string> {
  const cutoff = new Date(now);
  cutoff.setDate(cutoff.getDate() - 30);

  const names = new Set<string>();
  for (const revenue of revenueHistoryList) {
    if (!revenue.date || revenue.date < cutoff) continue;
    const categories = revenue.revenueData?.categories;
    if (!categories) continue;
    for (const category of categories) {
      for (const item of category.items) {
        if (item.name) names.add(item.name);
      }
    }
  }
  return names;
}
